(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["rv-mobile-ux"] && !Shopify.designMode) return;
  try {
    let riftValleyOverlayFrame = 0;

  const riftValleyCondenseCookieCopy = () => {
    const config = document.querySelector('.rv-mobile-ux');
    const paragraph = document.querySelector('#shopify-pc__banner .shopify-pc__banner__body p');
    const policyLink = paragraph?.querySelector('#shopify-pc__banner__body-policy-link');
    const condensedText = config?.dataset.rvCookieText?.trim();

    if (!paragraph || !policyLink || !condensedText || paragraph.dataset.rvCondensed === 'true') return;

    paragraph.replaceChildren(document.createTextNode(`${condensedText} `), policyLink);
    paragraph.dataset.rvCondensed = 'true';
  };

  const riftValleyElementVisible = (element) => {
    if (!element || element.getClientRects().length === 0) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden';
  };

  const riftValleyOverlayState = () => {
    const body = document.body;
    if (!body) return;

    riftValleyCondenseCookieCopy();

    if (!document.querySelector('[data-rv-floating-rewards]')) {
      const rewardLabels = [...document.querySelectorAll('button, a')].filter((element) => {
        const text = element.textContent.trim();
        return /^(prämien|praemien|rewards?)$/i.test(text);
      });

      rewardLabels.forEach((element) => {
        let current = element;
        while (current && current !== body) {
          if (getComputedStyle(current).position === 'fixed') {
            current.dataset.rvFloatingRewards = 'true';
            break;
          }
          current = current.parentElement;
        }
      });
    }

    const menuOpen = riftValleyElementVisible(document.querySelector('.main-menu__disclosure.is-open'));
    const drawerOpen = riftValleyElementVisible(document.querySelector('cart-drawer[open], quick-add-drawer[open], .drawer[open]'));
    const cookieOpen = riftValleyElementVisible(document.querySelector('#shopify-pc__banner'));
    const modalOpen = [...document.querySelectorAll('[role="dialog"]')].some((element) => {
      return riftValleyElementVisible(element) && element.getAttribute('aria-hidden') !== 'true';
    });
    body.dataset.rvCookieOpen = String(cookieOpen);
    body.dataset.rvOverlayActive = String(menuOpen || drawerOpen || cookieOpen || modalOpen);
  };

  const riftValleyScheduleOverlayState = () => {
    if (riftValleyOverlayFrame) return;

    riftValleyOverlayFrame = requestAnimationFrame(() => {
      riftValleyOverlayFrame = 0;
      riftValleyOverlayState();
    });
  };

  riftValleyScheduleOverlayState();
  document.addEventListener('click', riftValleyScheduleOverlayState);
  document.addEventListener('transitionend', riftValleyScheduleOverlayState);

  const riftValleyObserver = new MutationObserver(riftValleyScheduleOverlayState);
  riftValleyObserver.observe(document.documentElement, {
    attributes: true,
    childList: true,
    subtree: true,
    attributeFilter: ['class', 'open', 'aria-hidden', 'style']
  });
  } catch(e) { console.error(e); }
})();

})();
